export class RegistroUsuario {
    NombreEntidad: String;
    Email: String;
    Telefono: String;
    Nombre: String;
    CIF: String;
    IdDelegacion: number;
}
